/**
 * BoxAnimated — Generated by hearth-asset-pipeline
 * Furniture: 1×1 tiles
 * Generated: 2026-04-10T21:20:45.295Z
 *
 * This is a procedural isometric furniture renderer produced from a 3D model.
 * Integrates with Hearth's renderFurniture() dispatch and isoBox primitives.
 */

import { renderIsoAsset, type IsoAssetDef } from "../../render/iso-engine.js";

/** Furniture registry metadata */
export const BoxAnimated_META = {
  id: "BoxAnimated",
  name: "BoxAnimated",
  tileWidth: 1,
  tileHeight: 1,
  isoWidth: 25,
  isoDepth: 26,
  canonicalRot: 0 as const,
  interactionAnchors: [
    { type: "use_point", localWx: 0, localWy: 0, elevation: 0, faceDir: "S" },
  ],
} as const;

/** Declarative asset definition — pure data, no rendering code */
export const BoxAnimated_DEF: IsoAssetDef = {
  id: "BoxAnimated",
  name: "BoxAnimated",
  tile: [1, 1],
  geometry: { w: 32, d: 32, h: 38 },
  faces: {
    top: {
      base: "#4d82c1",
      palette: ["#4d82c1", "#4d81bf", "#4879b4", "#4778b2", "#4a7db9"],
      metalness: 0.00,
      roughness: 1.00,
      opacity: 1.00,
      materialType: "flat",
      edgeDarken: 0.20,
      edgeHighlight: 0.10,
    },
    left: {
      base: "#4271a8",
      palette: ["#4271a8", "#386294", "#a859a7", "#944d93", "#335b8a"],
      metalness: 0.00,
      roughness: 1.00,
      opacity: 1.00,
      materialType: "flat",
      gradient: { stops: [[0.00, "#695f9d"], [0.33, "#52659e"], [0.67, "#3d6a9e"], [1.00, "#3d6a9e"]], strength: 0.063 },
      edgeDarken: 0.20,
      edgeHighlight: 0.10,
    },
    right: {
      base: "#4a7fbc",
      palette: ["#4a7fbc", "#3f6ea6", "#bc64bb", "#a656a5", "#39669b"],
      metalness: 0.00,
      roughness: 1.00,
      opacity: 1.00,
      materialType: "flat",
      gradient: { stops: [[0.00, "#766ab0"], [0.33, "#5c71b1"], [0.67, "#4477b1"], [1.00, "#4477b1"]], strength: 0.063 },
      edgeDarken: 0.20,
      edgeHighlight: 0.10,
    },
  },
  anchors: [
    { type: "use_point", wx: 0, wy: 0, elevation: 0, dir: "S" },
  ],
};

/**
 * Render BoxAnimated via the shared isometric material engine.
 * Drop-in compatible with Hearth's renderFurniture() dispatch.
 */
export function renderBoxAnimated(
  ctx: CanvasRenderingContext2D,
  screenX: number,
  screenY: number,
  direction: 0 | 1 | 2 | 3,
  state: Record<string, unknown>,
  time: number,
): void {
  renderIsoAsset(ctx, BoxAnimated_DEF, screenX, screenY, direction, state, time);
}